module.exports = __webpack_public_path__ + "assets/images/logo2.bb43fb61.svg";